import { generatePath } from 'react-router-dom';

import { FINANCE_HUB } from '#client/constants/navItemsIds';
import * as ROUTES from '#client/constants/routes';

import { processMenu } from '../utils/menu';

/**
 * Get the finance hub menu.
 *
 * @param {{
 *  businessEntityUuid: string
 *  order?: number
 * }} params
 * @returns {object}
 */
export function getFinanceHubMenu({ businessEntityUuid, order }) {
  return processMenu({
    title: 'Finances',
    itemId: FINANCE_HUB,
    icon: 'money-fill.svg',
    path: generatePath(ROUTES.entityFinanceHub, { businessEntityUuid }),
    order
  });
}
